var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11381e-06 1.33868C1.12408e-06 1.1038 0.104722 0.879906 0.284569 0.721861C0.648815 0.407965 1.20429 0.429916 1.54122 0.770152L8.05896 7.42123L14.4515 0.774543C14.7861 0.432111 15.3416 0.407966 15.7081 0.719666C16.0633 1.02039 16.0997 1.54062 15.7878 1.88306C15.781 1.88964 15.7764 1.89623 15.7696 1.90281L8.72371 9.22558C8.55524 9.40119 8.31848 9.49996 8.07034 9.49996C7.8222 9.50216 7.58316 9.40557 7.41242 9.23216L0.236761 1.9072C0.0845119 1.75438 -0.000354616 1.55059 1.11381e-06 1.33868Z",
    fill: "#660099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.c09b2e472f0a9987dd8169ef61044376.svg";
export { ForwardRef as ReactComponent };